import { useState } from "react";
import Search from "../../ui/Search";

export default function SearchList({ setSearchText, searchText, setFilter, setParams }) {
  const [isSearched, setIsSearched] = useState(false);

  const handleSearchClear = () => {
    setSearchText("");
    setIsSearched(false);
  };

  const onSearch = (values) => {
    setSearchText(values.search);
    setFilter(null);
    setParams({ page: 1, ...values });
    setIsSearched(true);
  };
  return (
    <Search
      name={"search"}
      onSubmit={onSearch}
      placeholder={"Type anything..."}
      defaultValue={searchText}
      isSearched={isSearched}
      handleClear={handleSearchClear}
    />
  );
}
